export const environment = {
  production: true,
  hmr: false,
  canonicalDomain: 'https://coda-apeldoorn.nl',
};
